import * as jsxRuntime from "/opt/meituan/jenkins/slave/workspace/pepper-fe-mtunion-h5-production/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment